const AssetsBase = 'https://assets.gongji58.com'
const UsedCarPath = 'https://assets.gongji58.com/usedcar'
const MimagePath  = 'https://m.gongji58.com/images'
export default {
  AssetsBase,
  UsedCarPath,
  MimagePath
};
